<template>
  <BaseModal
    small
    :heading="$t('products.schedule_prices')"
    @close="emit('close')"
  >
    <Flex direction="column">
      <BaseText bold>
        {{ $t('products.schedule_changes_heading') }}
      </BaseText>
      <BaseDateTime
        v-model="dateTime"
        :label="$t('global.date_time')"
        :minValue="minValue"
        v-test="'schedule-date'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="emit('close')"
        v-test="'cancelSchedule'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        @click="emit('submit', dateTime)"
        v-test="'confirmSchedule'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
import dayjs from 'dayjs';
import { ref } from 'vue';
import BaseDateTime from '@/components/BaseDateTime.vue';

const emit = defineEmits(['close', 'submit']);
const dateTime = ref(dayjs().add(1, 'hour').format());
const minValue = dayjs().format();
</script>
